import type { FrontendWidget } from '../types';
import { NavigationGridComponent } from './NavigationGridComponent';
import type { NavigationGridConfig, NavigationGridResolved } from './types';
import { SectionBackgroundColor } from '@/lib/section-colors';

export const navigationGridWidget: FrontendWidget<
  NavigationGridConfig,
  NavigationGridResolved
> = {
  componentType: 'widgets.navigation-grid',
  displayName: 'Navigation Grid',
  ComponentA: NavigationGridComponent,
  resolveSync: (config) => ({
    background: config.background ?? SectionBackgroundColor.Sand,
    mobileBackground:
      config.mobileBackground ??
      config.background ??
      SectionBackgroundColor.Sand,
    cards: (config.cards ?? []).map((c) => ({
      id: c.id ?? 0,
      title: c.title ?? '',
      text: c.text ?? null,
      linkUrl: c.linkUrl ?? null,
      linkLabel: c.linkLabel ?? null,
      hasPlzFinder: c.hasPlzFinder ?? false,
      mobileOrder: c.mobileOrder ?? null,
    })),
  }),
};
